import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import * as XLSX from 'xlsx';
import {ConsultingService, LoaderService, ReportService} from '@app/shared/services';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {SelectDropDownModule} from 'ngx-select-dropdown';
import {PageHeaderComponent} from '@app/components/page-header/page-header.component';
import {UtilsInjectable} from '@app/shared';
import { ReportPdfComponent } from '@app/components/report-pdf/report-pdf.component';

const EXCEL_EXTENSION = '.xlsx';

@Component({
  selector: 'app-tax-report',
  templateUrl: './tax-report.component.html',
  styleUrls: ['./tax-report.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    SelectDropDownModule,
    PageHeaderComponent,
    ReportPdfComponent
  ]
})
export class TaxReportComponent implements OnInit {
  @ViewChild('table') table?: ElementRef;
  user_rights: any;
  user_data: any;
  stock_data: any;
  closeResult = '';
  medicine: any;
  sale_return_quantity: any;
  sale_quantity = 0;
  fromdate = new Date();
  todate = new Date();
  start: any;
  limit: any;
  states: any[] = [];
  state_options: any[] = [];
  vat_state: any;
  vat_statecode: any;
  state_data: any;
  state_id: any;
  state: any;
  rate: any;

  constructor(private loaderService: LoaderService,
              public consultingService: ConsultingService,
              public reportService: ReportService,
              public utils: UtilsInjectable,
  ) {
  }

  ngOnInit() {
    this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "{}");
    this.user_data = JSON.parse(localStorage.getItem('user') || "{}");
    this.fromdate = new Date(this.fromdate.getFullYear(), this.fromdate.getMonth(), 1, 23, 59, 59);
    this.todate = new Date();
    this.listTaxReport();
    this.listState();

  }

  public getToday(): string {
    return new Date().toISOString().split('T')[0]
  }

  public listTaxReport() {
    const postData = {
      invoice_date_from: this.fromdate,
      invoice_date_to: this.todate,
      rate: this.rate,
      state_data: this.state_data,
      start: this.start,
      limit: this.limit
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.consultingService.listTaxReport(postData).subscribe((result: any) => {
      this.loaderService.display(false);
      if (result['status'] == 'success') {
        this.stock_data = result['data'];
      } else {
        this.stock_data = []
      }
    });
  }

  public listState() {
    this.states = [];
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.reportService.listState().subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.states = result['state']['data'];
        this.state_options = this.states;
        this.vat_state = this.state_options[18].STATE_ID;
        this.vat_statecode = this.state_options[18].TIN_NUMBER;
        this.setState();
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);

      }
    });
  }

  public setState() {
    if (this.vat_state) {
      for (let index = 0; index < this.states.length; index++) {
        if (this.states[index].STATE_ID == this.vat_state) {
          this.state_data = this.states[index];
          break;
        }
      }
    }
  }

  getState() {
    this.vat_state = this.state_data.STATE_ID;
    this.vat_statecode = this.state_data.TIN_NUMBER;
  }

    public ExportToExcel() {
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table?.nativeElement, {
        dateNF: 'dd/mm/yyyy;@',
        cellDates: true,
        raw: true
      });
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      /* save to file */
      XLSX.writeFile(wb, 'Purchase' + new Date().getTime() + EXCEL_EXTENSION);
  
    }
}
